<template>
  <div class="component-page1">
    <img src="./page1.jpg" style="width: 100%" alt="">
  </div>
</template>

<script>
export default {
  name: "page1",
  components: {},
  props: {},
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  filters: {},
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.component-page1 {

}
</style>
<style lang="scss">
.component-page1_body { //dialog使用 customClass="xxx_body"

}
</style>
